import { Skeleton } from '~/components/ui/skeleton';

import { ContentPage } from '../ui-kit/content-page';

/** The Product page's shape while it loads: breadcrumb, title block with score card, tabs, body. */
export function ProductPageSkeleton() {
  return (
    <ContentPage className="gap-6">
      <Skeleton className="h-4 w-80 max-w-full" />
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="flex min-w-0 flex-1 gap-4">
          <Skeleton className="size-20 shrink-0 rounded-2xl" />
          <div className="flex flex-1 flex-col gap-3">
            <Skeleton className="h-7 w-full max-w-xl" />
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-6 w-96 max-w-full" />
          </div>
        </div>
        <Skeleton className="h-20 w-72 rounded-2xl" />
      </div>
      <Skeleton className="h-9 w-56" />
      <Skeleton className="h-10 w-full max-w-lg" />
      <Skeleton className="h-[360px] w-full rounded-2xl" />
    </ContentPage>
  );
}
